<div class="__header">
  <ng-content select="[formHeader]"></ng-content>
</div>

<div class="__body">
  <ng-content select="[formBody]"></ng-content>
</div>

<ng-content select="[formFooter]"></ng-content>
